import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

const Container = ({ children, className }: ContainerProps) => {
  return (
    <div className={cn("max-w-4xl mx-auto p-0 relative md:p-6", className)}>
      <main className="flex flex-col gap-6 rounded-none p-6 bg-white md:rounded-lg">
        {children}
      </main>
    </div>
  );
};

export default Container;
